<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'text', label: '문서번호' },
        { type: '보안등급', label: '보안등급' },
        { type: '보존년한', label: '보존년한' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="board"
      :is-print="isPrint"
    />

    <vs-tabs>
      <vs-tab v-for="(tab, index) in tabs" :key="index" :label="tab.label"
              @click="onTab(index)">
      </vs-tab>
    </vs-tabs>
    <div>
      <div v-if="currentTab === 0">
        <!-- 작업허가서 정보(신청자) -->
        <div>
          <h5 class="mb-4"><i class="dot"></i> 안전작업허가서 정보</h5>
          <div class="writeGridContainer">
            <div class="writeGridLineItem">
              <div>공장명</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.공장명 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.공장명" style="max-width: 372px;"/>
            </div>

            <div>
              <div>작업기간</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.작업기간시작 }} ~ {{ form.작업허가서정보.작업기간종료 }}</p>
              <div v-else class="time">
                <date-selector v-model="form.작업허가서정보.작업기간시작" :readonly="board.readonly" />
                <p class="px-2">~</p>
                <date-selector v-model="form.작업허가서정보.작업기간종료" :readonly="board.readonly" />
              </div>
            </div>
            <div>
              <div>공사금액</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.공사금액 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.공사금액" style="max-width: 372px;"/>
              <span>원</span>
            </div>
            <div>
              <div>작업업체명</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.작업업체명 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.작업업체명" style="max-width: 372px;"/>
            </div>

            <div>
              <div>작업자</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.작업자 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.작업자" />
              <span>명</span>
            </div>
            <div>
              <div>기본품의금액<br/>(총 공사비)</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.기본품의금액 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.기본품의금액" />
              <span>원</span>
            </div>
            <div>
              <div>산업안전관리비<br/>(계상금액)</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.산업안전관리비 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.산업안전관리비" />
              <span>원</span>
            </div>

            <div class="writeGridLineItem">
              <div>작업구역</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.작업구역 }}</p>
              <vs-select v-else class="w-full" autocomplete v-model="form.작업허가서정보.작업구역" >
                <vs-select-item v-for="item in ['a', 'b', 'c']" :text="item" :value="item"/>
              </vs-select>
            </div>
            <div class="writeGridLineItem">
              <div>공사/작업명</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.공사작업명 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.공사작업명" />
            </div>
            <div class="writeGridLineItem">
              <div>세부 작업내용</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.세부작업내용 }}</p>
              <ml-input v-else v-model="form.작업허가서정보.세부작업내용" />
            </div>
          </div>

          <h5 class="my-4"><i class="dot"></i> 보험 자료 확인사항</h5>
          <div class="writeGridContainer">
            <div>
              <div>산재보험 서류</div>
              <p v-if="isPrint" class="print-input flex-1">{{ form.산재보험서류 }}</p>
              <file-uploader v-else v-model="form.산재보험서류"/>
            </div>
            <div>
              <div>근재보험서류</div>
              <p v-if="isPrint" class="print-input flex-1">{{ form.근재보험서류 }}</p>
              <file-uploader v-else v-model="form.근재보험서류"/>
            </div>
            <div>
              <div>안전보건관리계획서</div>
              <p v-if="isPrint" class="print-input flex-1">{{ form.안전보건관리계획서 }}</p>
              <file-uploader v-else v-model="form.안전보건관리계획서"/>
            </div>
          </div>

          <h5 class="my-4"><i class="dot"></i> 안전관계자</h5>
          <div class="writeGridContainer">
            <div>
              <div>동국제강</div>
              <p v-if="isPrint">{{ form.작업허가서정보.동국제강 }}</p>
              <field-selector
                v-else
                v-model="form.작업허가서정보.동국제강"
                class="w-full flex-1" />
            </div>
            <div>
              <div>전화번호</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.동국제강전화번호 }}</p>
              <ml-input v-else readonly v-model="form.작업허가서정보.동국제강전화번호" />
            </div>
            <div/>

            <div>
              <div>공사업체</div>
              <p v-if="isPrint">{{ form.작업허가서정보.공사업체 }}</p>
              <field-selector
                v-else
                v-model="form.작업허가서정보.공사업체"
                class="w-full flex-1" />
            </div>
            <div>
              <div>전화번호</div>
              <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.공사업체전화번호 }}</p>
              <ml-input v-else readonly v-model="form.작업허가서정보.공사업체전화번호" />
            </div>
            <div/>
          </div>
        </div>

        <table>
          <tbody>
          <tr>
            <th>참고사항</th>
          </tr>
          <tr>
            <td>
              <div>1. 관리책임은 공사담당으로 안전작업허가서 승인자가 작업안전관리자가 되며, 신청부서의 부서장이 안전책임자가 된다.</div>
              <div>2. 산재(단체)보험은 보상한도액이 1인당 5억원 이상, 1사고당 5억원 이상이어야 하며, 보험증권을 확인해야한다.</div>
              <div>3. 신청자는 아래 필수서식을 작성, 작업 3일전까지 신청, 허가를 득하여야 하며 미허가시는 당해 작업이 제한될 수 있다.</div>
              <p>[동국제강 필수서식] 공사시방서</p>
              <p>[업체 필수서식] 각서, 산재/근재보험, 작업환경측정, 위험성평가, 안전보건관리비사용계획서, 공정별 안전대책, 건설업 기초안전보건교육 이수증</p>
              <p>[업체 추가서식] 안전협의체 회의록, 물질안전보건자료(GHS-MS DS), 중량물취급계획서, 차량게하역운반기계 계획서, 유해위험방지계획서, 재해예방 기술지도계약서</p>
            </td>
          </tr>
          </tbody>
        </table>

        <h5 class="my-4"><i class="dot"></i> 공사인원</h5>
        <div style="font-weight: 500">
          <p>※안내</p>
          <p>1. 출입자 변동시 수정등록 및 각 공장 안전 staff로 통보할 것</p>
          <p class="mx-4">- 인천공장 : 032-8230-6247 / 포항공장 : 054-721-3232 / 당진공장 : 041-351-4621 / 부산공장 : 051-640-5235 / 신평공장 : 051-220-3014</p>
          <p>2. 인원이 늘어날 경우 ‘인원추가’버튼을 이용하여 계속 추가할 수 있습니다.</p>
        </div>

        <table-custom
          :board="board"
          :is-print="isPrint"
          :tableData="[
            { id: 'no', title: '연번', type: 'no', width: 64 },
            { id: '성명', title: '성명', type: 'text', readonly: true, width: 164 },
            { id: '직위', title: '직위(직책)', type: 'select', selectData: ['시설 안전조치', '유지보수 업무', '기타 안전관리'], placeholder: '선택', width: 164 },
            { id: '생년월일', title: '생년월일(6자리)', type: 'text', readonly: true, width: 164 },
            { id: '주소', title: '주소', type: 'text', readonly: true },
            { id: '수료증', title: '건설업 기초안전보건교육 수료증', type: 'customType', width: 164 },
            ]"
          v-model="form.공사인원"
          :button-add-name="'인원추가(직접입력)'"
        >
          <template #buttons="{handleAddButton, handleRemoveButton}" >
            <div v-if="!board.readonly" style="text-align: right">
              <vs-button color="secondary" type="border" @click="onClickSearchEmployee"> 사용자 검색 </vs-button>
              <vs-button color="secondary" class="mx-2" @click="onClickAddEmployee"> 인원추가(직접입력) </vs-button>
              <vs-button color="secondary" type="border" @click="handleRemoveButton"> 선택삭제 </vs-button>
            </div>
          </template>
          <template #customType="{ row, id, index }">
            <file-uploader v-model="form.공사인원[index].수료증" />
          </template>
        </table-custom>

        <div class="mt-4 writeGridContainer">
          <div>
            <div>총 인원</div>
            <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.총인원 }}</p>
            <ml-input v-else v-model="form.작업허가서정보.총인원"/>
            <span>명</span>
          </div>
          <div>
            <div>남자</div>
            <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.남자 }}</p>
            <ml-input v-else v-model="form.작업허가서정보.남자"/>
            <span>명</span>
          </div>
          <div>
            <div>여자</div>
            <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.여자 }}</p>
            <ml-input v-else v-model="form.작업허가서정보.여자"/>
            <span>명</span>
          </div>

          <div>
            <div>업체 비상연락처</div>
            <p v-if="isPrint" class="print-input">{{ form.작업허가서정보.업체비상연락처 }}</p>
            <ml-input v-else v-model="form.작업허가서정보.업체비상연락처"/>
            <span>명</span>
          </div>
        </div>
      </div>

      <div v-else-if="currentTab === 1">
        <!-- 위험성평가 정보(발주부서) -->
        <div>
          <h5 class="mb-4"><i class="dot"></i> 위험성평가 정보</h5>
          <div class="writeGridContainer">
            <div>
              <div>평가일자</div>
              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.평가일자 }}</p>
              <date-selector v-else v-model="form.위험성평가정보.평가일자" />
            </div>
            <div class="writeGridCol2">
              <div>공정명</div>
              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.공장 }}</p>
              <ml-input v-else v-model="form.위험성평가정보.공장" style="max-width: 168px"/>
              <span>공장</span>
              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.팀 }}</p>
              <ml-input v-else v-model="form.위험성평가정보.팀" style="max-width: 168px"/>
              <span>팀</span>
              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.공정 }}</p>
              <ml-input v-else v-model="form.위험성평가정보.공정" style="max-width: 168px"/>
              <span>공정</span>
            </div>
            <div>
              <div>직영/협력</div>
              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.직영협력 }}</p>
              <div v-else class="w-full flex-1 flex gap-4">
                <vs-radio v-model="form.위험성평가정보.직영협력" :disabled="board.readonly" vs-name="직영협력" vs-value="직영">직영</vs-radio>
                <vs-radio v-model="form.위험성평가정보.직영협력" :disabled="board.readonly" vs-name="직영협력" vs-value="협력">협력</vs-radio>
              </div>
            </div>
          </div>

<!--          <div class="flex justify-between items-center my-4">-->
<!--            <h5><i class="dot"></i> 공정분류</h5>-->
<!--            <vs-button color="secondary" type="border" class="ml-2" @click="onClickSelectProgress"> 공정분류 선택 </vs-button>-->
<!--          </div>-->
<!--          <div class="writeGridContainer">-->
<!--            <div>-->
<!--              <div>대분류</div>-->
<!--              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.대분류 }}</p>-->
<!--              <ml-input v-else v-model="form.위험성평가정보.대분류" readonly />-->
<!--            </div>-->
<!--            <div>-->
<!--              <div>중분류</div>-->
<!--              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.중분류 }}</p>-->
<!--              <ml-input v-else v-model="form.위험성평가정보.중분류" readonly />-->
<!--            </div>-->
<!--            <div>-->
<!--              <div>소분류</div>-->
<!--              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.소분류 }}</p>-->
<!--              <ml-input v-else v-model="form.위험성평가정보.소분류" readonly />-->
<!--            </div>-->

<!--            <div>-->
<!--              <div>구분</div>-->
<!--              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.구분 }}</p>-->
<!--              <div v-else class="w-full flex-1 flex gap-4">-->
<!--                <vs-radio v-model="form.위험성평가정보.구분" :disabled="board.readonly" vs-name="구분" vs-value="상시">상시</vs-radio>-->
<!--                <vs-radio v-model="form.위험성평가정보.구분" :disabled="board.readonly" vs-name="구분" vs-value="돌발">돌발</vs-radio>-->
<!--                <vs-radio v-model="form.위험성평가정보.구분" :disabled="board.readonly" vs-name="구분" vs-value="임시">임시</vs-radio>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <!-- 공정분류 -->
          <maot-section title="공정분류">
            <template #right>
              <select895-button v-if="!(board.readonly)" v-model="form.공정분류.raw" @input="onSelectProcess"/>
            </template>
            <div class="col-span-12 writeGridContainer m-0">
              <div>
                <div>대분류</div>
                <ml-input v-model="form.공정분류.대분류" readonly/>
              </div>
              <div>
                <div>중분류</div>
                <ml-input v-model="form.공정분류.중분류" readonly/>
              </div>
              <div>
                <div>소분류</div>
                <ml-input v-model="form.공정분류.소분류" readonly/>
              </div>

              <div>
                <div>구분</div>
                <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.구분 }}</p>
                <div v-else class="w-full flex-1 flex gap-4">
                  <vs-radio v-model="form.위험성평가정보.구분" :disabled="board.readonly" vs-name="구분" vs-value="상시">상시</vs-radio>
                  <vs-radio v-model="form.위험성평가정보.구분" :disabled="board.readonly" vs-name="구분" vs-value="돌발">돌발</vs-radio>
                  <vs-radio v-model="form.위험성평가정보.구분" :disabled="board.readonly" vs-name="구분" vs-value="임시">임시</vs-radio>
                </div>
              </div>
            </div>
          </maot-section>

          <table-custom
            :board="board"
            :is-print="isPrint"
            :tableData="[
              { id: '일', title: '일', type: 'text', placeholder: '입력' },
              { id: '주', title: '주', type: 'text', placeholder: '입력' },
              { id: '월', title: '월', type: 'text', placeholder: '입력' },
              { id: '분기', title: '분기', type: 'text', placeholder: '입력' },
              { id: '년', title: '년', type: 'text', placeholder: '입력' },
              { id: '1회 작업시간(분)', title: '1회 작업시간(분)', type: 'text', placeholder: '입력' },
            ]"
            v-model="form.작업빈도"
            title="작업빈도(횟수)"
            :controls="false"
            :multiple="false"
          />

          <h5 class="my-4"><i class="dot"></i> 담당</h5>
          <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
          <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />

          <h5 class="my-4"><i class="dot"></i> 동일직무인원</h5>
          <div class="writeGridContainer mb-8">
            <div>
              <div>상주반</div>
              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.상주반 }}</p>
              <ml-input v-else v-model="form.위험성평가정보.상주반" />
              <span>명</span>
            </div>
            <div>
              <div>교대반</div>
              <p v-if="isPrint" class="print-input">{{ form.위험성평가정보.교대반 }}</p>
              <ml-input v-else v-model="form.위험성평가정보.교대반" />
              <span>명</span>
            </div>
          </div>

          <!-- 위험성평가표 (814) -->
          <maot-section>
            <template #title>
              위험성평가표
              <span style="font-size: 1rem; font-weight: 500; color: #3c3c3c;">「발생빈도」, 「위험강도」등록시는 평가기준을 확인하시기 바라며, 「완료일」은 연월일(YYYY-MM-DD)로 등록 바랍니다.</span>
            </template>
            <table-custom
              class="col-span-12"
              border-x
              customThead
              :board="board"
              :controls="!(board.readonly)"
              :is-print="isPrint"

              :tableData="DKRASTableData"
              :mobile="['분류', '원인', '발생빈도', '위험강도', '단위위험', '담당자', '완료예정일']"
              :default-size="5"
              v-model="form.위험성평가표.data"
            >
              <template #customTitle>
                <div class="writeGridContainer" style="width: 66.66%">
                  <div class="col-span-6">
                    <div>위험도</div>
                    <div>
                      <div class="print-input">{{ form.위험성평가표.위험도 }}</div>
                    </div>
                  </div>
                  <div class="col-span-6">
                    <div>중요위험</div>
                    <div class="print-input">{{ form.위험성평가표.중요위험 }}</div>
                  </div>
                </div>
              </template>
              <template #customHead="{allCheckValue, onClickAllCheck, mobile, readonly}">
                <fragment v-if="$viewport.isMobile">
                  <tr>
                    <th v-if="!readonly" style="padding: 6px;">
                      <div class="p-1 flex justify-center items-center">
                        <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
                      </div>
                    </th>
                    <th>분류</th>
                    <th>원인</th>
                    <th>발생빈도</th>
                    <th>위험강도</th>
                    <th>단위위험</th>
                    <th>담당자</th>
                    <th>완료일(예정일)</th>
                    <th></th>
                  </tr>
                </fragment>
                <fragment v-else>
                  <tr>
                    <th v-if="!readonly" rowspan="2" class="p-1"><vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox></th>
                    <th rowspan="2">분류</th>
                    <th rowspan="2">원인</th>
                    <th rowspan="2">위험요인</th>
                    <th rowspan="2">현재조치 관리상태</th>
                    <th rowspan="1" colspan="3">현재 위험도</th>
                    <th rowspan="2">감소대책</th>
                    <th rowspan="2">담당자</th>
                    <th rowspan="2">완료일(예정일)</th>
                    <th rowspan="1" colspan="2">적합성검토</th>
                  </tr>
                  <tr>
                    <th><div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.빈도 = true">
                      <span>발생빈도</span>
                      <feather-icon style="width: 20px; color:#7E72F2;" icon="AlertCircleIcon"/>
                    </div></th>
                    <th><div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.강도 = true">
                      <span>위험강도</span>
                      <feather-icon style="width: 20px; color:#7E72F2;" icon="AlertCircleIcon"/>
                    </div></th>
                    <th><div class="flex justify-center items-center cursor-pointer gap-1" style="line-height: 1" @click="popup.위험도 = true">
                      <span>단위위험</span>
                      <feather-icon style="width: 20px; color:#7E72F2;" icon="AlertCircleIcon"/>
                    </div></th>
                    <th>1차</th>
                    <th>2차</th>
                  </tr>
                </fragment>
              </template>
              <template #customType="{ row, id, index }">
                <div v-if="id === '분류'" class="">
                  <risk-fact-selector v-model="form.위험성평가표.data[index].분류" />
                </div>
                <div v-else-if="id === '원인'" class="">
                  <risk-fact-selector v-model="form.위험성평가표.data[index].원인"
                                      :분류="form.위험성평가표.data[index].분류 || ' '"/>
                </div>
                <div v-else-if="id === '단위위험'" class="">
                  <div class="print-input" :style="{color: getRiskColor(form.위험성평가표.data[index].위험도)}">{{ form.위험성평가표.data[index].단위위험 }}</div>
                  <div v-if="form.위험성평가표.data[index].위험도 >= 20" style="color: #EA5455">※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
                </div>
              </template>
            </table-custom>
            <div class="col-span-12 writeGridContainer mt-2 row-gap-2">
              <div class="writeGridLineItem">
                <div>안전보호구</div>
                <div><ml-input v-model="form.위험성평가표.안전보호구" :readonly="board.readonly"/></div>
              </div>
              <div class="writeGridLineItem">
                <div>정리정돈사항</div>
                <div><ml-input v-model="form.위험성평가표.정리정돈사항" :readonly="board.readonly"/></div>
              </div>
              <div class="writeGridLineItem">
                <div>ONE POINT</div>
                <div><ml-input v-model="form.위험성평가표.ONEPOINT" :readonly="board.readonly"/></div>
              </div>
            </div>
          </maot-section>
        </div>
        <div class="writeGridContainer">
          <div class="writeGridLineItem" style="align-items: center;">
            <div>일반작업(Check)</div>
            <template v-if="isPrint">
              <div class="item-box-check" v-if="form.위험성평가표작업.일반작업" style="text-align: center;  align-self: center;">
                <vs-icon icon="check" size="small"  ></vs-icon>
              </div>
              <div v-else class="item-box-check">
              </div>
              일반 보수정비 작업
            </template>
            <vs-checkbox v-model="form.위험성평가표작업.일반작업" :disabled="board.readonly" >일반 보수정비 작업</vs-checkbox>
          </div>

          <div class="writeGridLineItem" style="align-items: center;">
            <div>보충항목(Check)</div>
            <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
              <div v-for="item in form.위험성평가표작업.보충항목" class="col-span-2">
                <template v-if="isPrint">
                  <div class="item-box-check" v-if="form.위험성평가표작업.보충항목.includes(item.label)" style="text-align: center;  align-self: center;">
                    <vs-icon icon="check" size="small"  ></vs-icon>
                  </div>
                  <div v-else class="item-box-check">
                  </div>
                  {{ item.label }}
                </template>
                <vs-checkbox v-model="item.check" :disabled="board.readonly" >{{ item.label}}</vs-checkbox>
              </div>
            </div>
          </div>

          <div class="writeGridLineItem" style="align-items: center;">
            <div style="line-height: normal;">환경 RISK검토(Check)</div>
            <p v-if="isPrint" class="print-input">{{ form.위험성평가표작업.환경리스크검토 }}</p>
            <div v-else class="w-full flex-1 flex gap-4">
              <vs-radio v-model="form.위험성평가표작업.환경리스크검토" :disabled="board.readonly" vs-name="환경리스크검토" vs-value="해당있음">해당있음</vs-radio>
              <vs-radio v-model="form.위험성평가표작업.환경리스크검토" :disabled="board.readonly" vs-name="환경리스크검토" vs-value="해당없음">해당없음</vs-radio>
              <vs-button color="secondary" @click="onClickEnviromentWrite"> 환경영향평가서 작성 </vs-button>
            </div>
          </div>

          <div class="writeGridLineItem">
            <div />
            <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
              <div v-for="item in form.위험성평가표작업.환경리스크검토의견" class="col-span-2">
                <template v-if="isPrint">
                  <div class="item-box-check" v-if="form.위험성평가표작업.환경리스크검토의견.includes(item.label)" style="text-align: center;  align-self: center;">
                    <vs-icon icon="check" size="small"  ></vs-icon>
                  </div>
                  <div v-else class="item-box-check">
                  </div>
                  {{ item.label }}
                </template>
                <vs-checkbox v-model="item.check" :disabled="board.readonly" >{{ item.label}}</vs-checkbox>
              </div>
            </div>
          </div>

          <div class="writeGridLineItem" style="align-items: center;">
            <div>출입/작업시 필수 안전조치</div>
            <template v-if="isPrint">
              <div class="item-box-check" v-if="form.위험성평가표작업.필수안전조치" style="text-align: center;  align-self: center;">
                <vs-icon icon="check" size="small"  ></vs-icon>
              </div>
              <div v-else class="item-box-check">
              </div>
              (필수확인)
            </template>
            <vs-checkbox v-model="form.위험성평가표작업.필수안전조치" :disabled="board.readonly" >(필수확인)</vs-checkbox>
          </div>

          <div class="writeGridLineItem" style="align-items: center;">
            <div style="line-height: normal;">중요위험 해당여부</div>
            <p v-if="isPrint" class="print-input">{{ form.위험성평가표작업.중요위험해당여부 }}</p>
            <div v-else class="w-full flex-1 flex gap-4">
              <vs-radio v-model="form.위험성평가표작업.중요위험해당여부" :disabled="board.readonly" vs-name="중요위험해당여부" vs-value="Y">Y</vs-radio>
              <vs-radio v-model="form.위험성평가표작업.중요위험해당여부" :disabled="board.readonly" vs-name="중요위험해당여부" vs-value="N">N</vs-radio>
            </div>
          </div>
        </div>

        <table-custom
          class="mt-4"
          :board="board"
          :is-print="isPrint"
          title="중요위험"
          :tableData="[
               { id: 'no', title: 'No.', type: 'no', width: '64px' },
              { id: '위험요인', title: '위험요인', type: 'textarea', },
              { id: '개선대책', title: '개선대책', type: 'textarea', },
            ]"
          v-model="form.중요위험"
        />

      </div>
      <div v-else-if="currentTab === 2">
        <!-- 사외수급업체 서류평가(사전) 작성 -->
        <div>
          <h5 class="mb-4"><i class="dot"></i> 사외수급업체 서류평가(사전) 작성</h5>
          <div class="writeGridContainer">
            <div class="writeGridLineItem">
              <div>서류평가 작성</div>
              <div class="flex">
                <vs-button color="secondary" @click="onClickDocsWrite"> 사외수급업체 서류평가 작성 </vs-button>
                <vs-button color="secondary" type="border" class="ml-2" @click="onClickDocsView"> 작성 사외수급업체 서류평가 보기 </vs-button>
              </div>
            </div>
            <div class="writeGridLineItem">
              <div>환경 Risk 검토의견</div>
              <p v-if="isPrint" class="print-input">{{ form.서류평가.환경검토의견 }}</p>
              <ml-textarea v-else v-model="form.서류평가.환경검토의견" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from '@/components/FileUploader.vue'
import FieldSelector from "@/components/selector/FieldSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import MaotSection from "@/components/layout/MaotSection.vue";
import Select895Button from "@/views/boards/single-page/895/Select895Button.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import RiskFactSelector from "@/components/selector/riskFactor/RiskFactSelector.vue";

export default {
  components: {
    RiskFactSelector,
    CustomOptionSelector,
    RadioGroup,
    Select895Button,
    MaotSection,
    NameWithSignatureRow,
    TableCustom,
    FieldSelector,
    FileUploader,
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    ecoFlow() {
      return ecoFlow
    },
    selectEcoFlowId() {
      return this.$route.query.p;
    }
  },
  data() {
    return {
      popup: {
        빈도: false,
        강도: false,
        위험도: false,
        warning20: false,
      },
      currentTab: 0,
      tabs: [
        { label: '작업허가서 정보(신청자)' },
        { label: '위험성평가 정보(발주부서)' },
        { label: '사외수급업체 서류평가(안전환경팀)' },
      ],

      DKRASTableData: [
        { id: '분류', title: '분류', type: 'customType', width: '132px'},
        { id: '원인', title: '원인', type: 'customType', width: '132px'},
        { id: '위험요인', title: '위험요인', type: 'textarea', width: '132px'},
        { id: '현재조치관리상태', title: '현재조치 관리상태', type: 'textarea', width: '132px'},
        { id: '발생빈도', title: '발생빈도', type: 'select', selectData: ['5', '4', '3', '2', '1'], width: '83px'},
        { id: '위험강도', title: '위험강도', type: 'select', selectData: ['5', '4', '3', '2', '1'], width: '83px'},
        { id: '단위위험', title: '단위위험', type: 'customType', width: '114px'},
        { id: '감소대책', title: '감소대책', type: 'textarea', width: '132px'},
        { id: '담당자', title: '담당자', type: 'text', width: '132px'},
        { id: '완료예정일', title: '완료예정일', type: 'date', width: '132px'},
        { id: '검토1차', title: '1차', type: 'radio', radioItems: [{value: 'Y'}, {value: 'N'}], width: '90px', defaultValue: 'Y' },
        { id: '검토2차', title: '2차', type: 'radio', radioItems: [{value: 'Y'}, {value: 'N'}], width: '90px', defaultValue: 'Y' },
      ],

      form: {
        stdInfo: {},
        작업허가서정보: {},
        위험성평가정보: {
          평가일자: "",
          공장: "",
          팀: "",
          공정: "",
        },
        서류평가: {},

        산재보험서류: {},
        근재보험서류: {},
        안전보건관리계획서: {},
        공사인원: [
          { id: '1', no: 1, 성명: '', 직위: '', 생년월일: '', 주소: '', 수료증: {} },
        ],

        공정분류: {
          대분류: "",
          중분류: "",
          소분류: "",
          raw: undefined,
        },
        작업빈도: [],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },

        위험성평가표: {
          위험도: "",
          중요위험: "",
          data: [],
          안전보호구: "",
          정리정돈사항: "",
          ONEPOINT: "",
        },
        위험성평가표작업: {
          일반작업: false,
          보충항목: [
            { label: '화기 작업', check: false },
            { label: '밀폐공간 작업', check: false },
            { label: '굴착 작업', check: false },
            { label: '고소 작업', check: false },
            { label: '석면해체 작업', check: false },
            { label: '전기 차단작업', check: false },
            { label: '중장비 작업', check: false },
            { label: '방사능 관련 직업', check: false },
            { label: '유해위험방지계획서', check: false },
            { label: '환경영향평가', check: false },
          ],
          환경리스크검토: "",
          환경리스크검토의견: [
            { label: '신규설비 도입/변경', check: false },
            { label: '화학물질 사용/변경', check: false },
            { label: '오염물질발생(폐기물)', check: false },
            { label: '원·부원료 사용/변경', check: false },
          ],
          필수안전조치: false,
          중요위험해당여부: "",

        },
        중요위험: [],


        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.위험성평가표.data': {
      deep: true,
      handler(list) {
        if (list && list.length > 0) {
          let sum위험도 = 0;
          let is중요위험 = false;
          this.is위험도20 = false;
          list = list.map((item, index) => {
            const 발생빈도 = Number(item.발생빈도 || 0)
            const 위험강도 = Number(item.위험강도 || 0);
            const 위험도 = 발생빈도 * 위험강도
            sum위험도 += 위험도;
            if (발생빈도 >=5 || 위험도 >= 10) {
              is중요위험 = true;
            }

            item.위험도 = 위험도
            item.단위위험 = this.getRisk(위험도);

            if (위험도 >= 20) {
              this.is위험도20 = true;
            }

            // 개선후 위험도
            if (this.isRevision) {
              const 개선후_발생빈도 = Number(item.개선후_발생빈도 || 0)
              const 개선후_위험강도 = Number(item.개선후_위험강도 || 0);
              const 개선후_위험도 = 개선후_발생빈도 * 개선후_위험강도
              item.개선후_위험도 = 개선후_위험도
              item.개선후_단위위험 = this.getRisk(개선후_위험도);
            }

            return item;
          });
          this.form.위험성평가표.위험도 = (sum위험도 / list.length).toFixed(1);
          this.form.위험성평가표.중요위험 = is중요위험 ? "Y" : "N";
        }
      },
    },
  },
  methods: {
    onTab(index) {
      this.currentTab = index;
    },
    onClickSearchEmployee() {
      this.showPopup = true;
    },
    onClickAddEmployee() {
      this.form.공사인원.push({
        id: Math.random().toString(36).substr(2, 9), no: this.form.공사인원.length + 1,
        성명: '', 직위: '', 생년월일: '', 주소: '', 수료증: {} });
    },
    onClickRemoveEmployee(checkData) {
      this.form.공사인원 = this.form.공사인원.filter((item) => !checkData.includes(item.id));
    },

    onClickDocsWrite() {

    },
    onClickDocsView() {

    },

    getRisk(위험도) {
      if (위험도 >= 20) return "중요위험(허용불가능)"
      if (위험도 >= 10) return "중요위험(허용가능)"
      return "일반"
    },
    getRiskColor(위험도) {
      if (위험도 >= 20) return "#EA5455"
      if (위험도 >= 10) return "#FF9F43"
      return "#28C76F"
    },
    onSelectProcess (raw) {
      this.form.공정분류.대분류 = raw.대분류
      this.form.공정분류.중분류 = raw.중분류
      this.form.공정분류.소분류 = raw.소분류
      this.form.위험성평가정보.공장 = raw.공장명
      this.form.위험성평가정보.팀 = raw.업체명
    },
    onClickEnviromentWrite() {

    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    background-color: #f9f9f9;
    text-align: center;
  }
  th, td {
    padding: 14px;
    border: 1px solid #cdcdcd;

    div {
      font-weight: 500;
    }
    p {
      font-weight: 400;
    }
  }

}
</style>
